let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dxBwJ")).then(() => parcelRequire('89vNJ'));